const options = [
  {
    key: 'my-profile',
    label: 'sidebar.profile',
    leftIcon: 'ion-person'
  }
];
export default options;
